const getUserProfile = (perfis, id) => {
	const perfil = perfis.find(p => p.id === id)
	return (perfil && perfil.nome)
}

export { getUserProfile }
